import Service from './Service';

export default class MailTemplateService extends Service{
    constructor() {
        super();
        this.baseURL = 'mailTemplate';
    }

}